import type { Variants } from 'motion/react';

export const cardContainerVariants: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.95,
    y: 20,
  },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1],
    },
  },
};

export const cardWidthVariants: Variants = {
  narrow: {
    maxWidth: '28rem',
    transition: {
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1],
    },
  },
  wide: {
    maxWidth: '56rem',
    transition: {
      duration: 0.7,
      delay: 1.5,
      ease: [0.16, 1, 0.3, 1],
    },
  },
};

export const videoVariants: Variants = {
  hidden: {
    opacity: 0,
    x: 40,
    scale: 1.05,
    clipPath: 'inset(0 100% 0 0)',
  },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    clipPath: 'inset(0 0% 0 0)',
    transition: {
      duration: 0.7,
      delay: 1.5,
      ease: [0.16, 1, 0.3, 1],
    },
  },
};

export const containerVariants: Variants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1,
    },
  },
};
